import { createContext } from 'react';

const PlannedOrdersContext = createContext(null);

export default PlannedOrdersContext;
